/**
 * @fileoverview Landing page hero section with animated background.
 * @module features/landing/components/HeroSection
 */

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { LandingMetrics } from './LandingMetrics'

/**
 * Hero section with animated gradient blobs, headline, and CTAs.
 *
 * @component
 */
export function HeroSection(): ReactElement {
  const { t } = useTranslation('features-landing')

  return (
    <section className="relative pt-12 pb-24 lg:pt-32 lg:pb-40 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-left space-y-8 animate-fade-in-up">
          {/* Main Headline */}
          <h1 className="text-2xl md:text-4xl lg:text-7xl font-heading font-medium tracking-tight text-foreground">
            {t('hero.headline1')}
          </h1>
          <p className="text-xl md:text-2xl lg:text-4xl font-light text-muted-foreground">
            {t('hero.headline2')}
          </p>

          {/* Metrics Preview */}
          <div className="pt-4">
            <LandingMetrics />
          </div>


        </div>
      </div>
    </section>
  )
}
